
/* styles */
require("!!../../../../node_modules/.2.1.0@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/.11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4308acbe\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?{\"sourceMap\":true}!../../../../node_modules/.11.3.4@vue-loader/lib/selector?type=styles&index=0!./Save.vue")

var Component = require("!../../../../node_modules/.11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.11.3.4@vue-loader/lib/selector?type=script&index=0!./Save.vue"),
  /* template */
  require("!!../../../../node_modules/.11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4308acbe\"}!../../../../node_modules/.11.3.4@vue-loader/lib/selector?type=template&index=0!./Save.vue"),
  /* scopeId */
  "data-v-4308acbe",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/nav/save/Save.vue
// module id = 149
// module chunks = 1